// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VendorWeddingInfo_progressMain__UDkTZ {
  background: var(--bg3);
  padding: 16px;
  border-radius: var(--border-radius-large);
  margin-top: 16px;
}
.VendorWeddingInfo_progressMain__UDkTZ .VendorWeddingInfo_completeProfileTitle__UhkXZ {
  font: var(--h6);
  font-weight: 600;
  margin: 0 0 16px 0;
  color: var(--primary-Text);
}
.VendorWeddingInfo_progressMain__UDkTZ .VendorWeddingInfo_getStartRow__f1mnR {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
}
.VendorWeddingInfo_progressMain__UDkTZ .VendorWeddingInfo_getStartRow__f1mnR h6 {
  font: var(--body-font-three);
  font-weight: 600;
  color: var(--brand);
  text-transform: capitalize;
}
.VendorWeddingInfo_progressMain__UDkTZ .VendorWeddingInfo_getStartRow__f1mnR button img {
  width: 20px;
  height: 20px;
  filter: brightness(0) invert(1);
}

.VendorWeddingInfo_modalBody__A77sY {
  max-width: 800px !important;
  max-height: 80dvh !important;
  overflow-y: auto !important;
}

.VendorWeddingInfo_header__1H4HN {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
}
.VendorWeddingInfo_header__1H4HN h3 {
  font: var(--h6);
  font-weight: 600;
  color: var(--primary-Text);
}

.VendorWeddingInfo_formField__zQ1So .VendorWeddingInfo_label__qnq5D {
  font: var(--body-font-three);
  color: var(--secondary-Text);
  display: block;
  margin-bottom: 4px;
}

.VendorWeddingInfo_photographyTimelineRow__ZMop8 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin: 15px 0;
}
.VendorWeddingInfo_photographyTimelineRow__ZMop8 .VendorWeddingInfo_formField__zQ1So {
  width: 100%;
}
.VendorWeddingInfo_photographyTimelineRow__ZMop8 .VendorWeddingInfo_deleteRowBtn__j5Qh8 {
  width: 40px;
}
.VendorWeddingInfo_photographyTimelineRow__ZMop8 .VendorWeddingInfo_deleteRowBtn__j5Qh8 button {
  width: 100%;
}

.VendorWeddingInfo_VendorModalBody__cnSLu .VendorWeddingInfo_VendorModalBodyButtons__9xyGF {
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
  align-items: center;
  gap: 8px;
}
.VendorWeddingInfo_VendorModalBody__cnSLu .VendorWeddingInfo_VendorModalBodyButtons__9xyGF .VendorWeddingInfo_VendorModalBodyButtonsItem__woTsE {
  font: var(--body-font-three);
  font-weight: 500;
  color: var(--secondary-Text);
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: white;
  border: 1px solid var(--border);
}
.VendorWeddingInfo_VendorModalBody__cnSLu .VendorWeddingInfo_VendorModalBodyButtons__9xyGF .VendorWeddingInfo_VendorModalBodyButtonsItem__woTsE:hover {
  background: var(--bg3);
  color: var(--brand);
  border-color: var(--brand);
}
.VendorWeddingInfo_VendorModalBody__cnSLu .VendorWeddingInfo_VendorModalBodyButtons__9xyGF .VendorWeddingInfo_VendorModalBodyButtonsItem__woTsE.VendorWeddingInfo_active__YbkWB {
  background: var(--bg3);
  color: var(--brand);
  border-color: var(--brand);
}
.VendorWeddingInfo_VendorModalBody__cnSLu .VendorWeddingInfo_VendorModalBodyContent__oplpW {
  transition: all 0.3s ease;
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.VendorWeddingInfo_VendorModalBody__cnSLu .VendorWeddingInfo_VendorModalBodyContent__oplpW .VendorWeddingInfo_Title__YKtBy {
  font: var(--h6);
  font-weight: 600;
  color: var(--primary-Text);
}`, "",{"version":3,"sources":["webpack://./src/components/VendorWeddingInfo/index.module.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;EACA,aAAA;EACA,yCAAA;EACA,gBAAA;AACJ;AACI;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,0BAAA;AACR;AAEI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AAAR;AAEQ;EACI,4BAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;AAAZ;AAIY;EACI,WAAA;EACA,YAAA;EACA,+BAAA;AAFhB;;AAQA;EACI,2BAAA;EACA,4BAAA;EACA,2BAAA;AALJ;;AAQA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AALJ;AAOI;EACI,eAAA;EACA,gBAAA;EACA,0BAAA;AALR;;AAUI;EACI,4BAAA;EACA,4BAAA;EACA,cAAA;EACA,kBAAA;AAPR;;AAWA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AARJ;AAUI;EACI,WAAA;AARR;AAWI;EACI,WAAA;AATR;AAWQ;EACI,WAAA;AATZ;;AAeI;EACI,aAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;AAZR;AAcQ;EACI,4BAAA;EACA,gBAAA;EACA,4BAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;EACA,+BAAA;AAZZ;AAcY;EACI,sBAAA;EACA,mBAAA;EACA,0BAAA;AAZhB;AAeY;EACI,sBAAA;EACA,mBAAA;EACA,0BAAA;AAbhB;AAkBI;EACI,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAhBR;AAkBQ;EACI,eAAA;EACA,gBAAA;EACA,0BAAA;AAhBZ","sourcesContent":[".progressMain {\r\n    background: var(--bg3);\r\n    padding: 16px;\r\n    border-radius: var(--border-radius-large);\r\n    margin-top: 16px;\r\n\r\n    .completeProfileTitle {\r\n        font: var(--h6);\r\n        font-weight: 600;\r\n        margin: 0 0 16px 0;\r\n        color: var(--primary-Text);\r\n    }\r\n\r\n    .getStartRow {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n        margin-top: 16px;\r\n\r\n        h6 {\r\n            font: var(--body-font-three);\r\n            font-weight: 600;\r\n            color: var(--brand);\r\n            text-transform: capitalize;\r\n        }\r\n\r\n        button {\r\n            img {\r\n                width: 20px;\r\n                height: 20px;\r\n                filter: brightness(0) invert(1);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.modalBody {\r\n    max-width: 800px !important;\r\n    max-height: 80dvh !important;\r\n    overflow-y: auto !important;\r\n}\r\n\r\n.header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    gap: 16px;\r\n    margin-bottom: 12px;\r\n\r\n    h3 {\r\n        font: var(--h6);\r\n        font-weight: 600;\r\n        color: var(--primary-Text);\r\n    }\r\n}\r\n\r\n.formField {\r\n    .label {\r\n        font: var(--body-font-three);\r\n        color: var(--secondary-Text);\r\n        display: block;\r\n        margin-bottom: 4px;\r\n    }\r\n}\r\n\r\n.photographyTimelineRow {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    gap: 16px;\r\n    margin: 15px 0;\r\n\r\n    .formField {\r\n        width: 100%;\r\n    }\r\n\r\n    .deleteRowBtn {\r\n        width: 40px;\r\n\r\n        button {\r\n            width: 100%;\r\n        }\r\n    }\r\n}\r\n\r\n.VendorModalBody {\r\n    .VendorModalBodyButtons {\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n        justify-content: start;\r\n        align-items: center;\r\n        gap: 8px;\r\n\r\n        .VendorModalBodyButtonsItem {\r\n            font: var(--body-font-three);\r\n            font-weight: 500;\r\n            color: var(--secondary-Text);\r\n            padding: 8px 12px;\r\n            border-radius: 6px;\r\n            cursor: pointer;\r\n            transition: all 0.3s ease;\r\n            background: white;\r\n            border: 1px solid var(--border);\r\n\r\n            &:hover {\r\n                background: var(--bg3);\r\n                color: var(--brand);\r\n                border-color: var(--brand);\r\n            }\r\n\r\n            &.active {\r\n                background: var(--bg3);\r\n                color: var(--brand);\r\n                border-color: var(--brand);\r\n            }\r\n        }\r\n    }\r\n\r\n    .VendorModalBodyContent {\r\n        transition: all 0.3s ease;\r\n        margin-top: 24px;\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: 24px;\r\n\r\n        .Title {\r\n            font: var(--h6);\r\n            font-weight: 600;\r\n            color: var(--primary-Text);\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"progressMain": `VendorWeddingInfo_progressMain__UDkTZ`,
	"completeProfileTitle": `VendorWeddingInfo_completeProfileTitle__UhkXZ`,
	"getStartRow": `VendorWeddingInfo_getStartRow__f1mnR`,
	"modalBody": `VendorWeddingInfo_modalBody__A77sY`,
	"header": `VendorWeddingInfo_header__1H4HN`,
	"formField": `VendorWeddingInfo_formField__zQ1So`,
	"label": `VendorWeddingInfo_label__qnq5D`,
	"photographyTimelineRow": `VendorWeddingInfo_photographyTimelineRow__ZMop8`,
	"deleteRowBtn": `VendorWeddingInfo_deleteRowBtn__j5Qh8`,
	"VendorModalBody": `VendorWeddingInfo_VendorModalBody__cnSLu`,
	"VendorModalBodyButtons": `VendorWeddingInfo_VendorModalBodyButtons__9xyGF`,
	"VendorModalBodyButtonsItem": `VendorWeddingInfo_VendorModalBodyButtonsItem__woTsE`,
	"active": `VendorWeddingInfo_active__YbkWB`,
	"VendorModalBodyContent": `VendorWeddingInfo_VendorModalBodyContent__oplpW`,
	"Title": `VendorWeddingInfo_Title__YKtBy`
};
export default ___CSS_LOADER_EXPORT___;
